import React, {FC} from 'react';
import {Drop} from '../../../../grpc_client/grips/protos/shared/drop';
import {useIndividualDropSubscriptionStatus} from '../../../../pages/Drops/Overview/useIndividualDropSubscriptionStatus';
import {useIsIndividualDropSubscribed} from '../../../../pages/Drops/Overview/useIsIndividualDropSubscribed';
import {useIsSubscribed} from '../../../../pages/Drops/Overview/useIsSubscribed';
import {useDropsTranslationContext} from '../../../../pages/Drops/context/TranslationProvider';
import DropTeaser from '../Teaser/Teaser';

export const UpcomingDrop: FC<{
  drop: Drop;
}> = ({drop}) => {
  const translations = useDropsTranslationContext();
  const isAllDropsSubscribed = useIsSubscribed();
  const isIndividualDropSubscribed = useIsIndividualDropSubscribed(drop.id);
  const isSubscribed = isIndividualDropSubscribed || isAllDropsSubscribed;

  useIndividualDropSubscriptionStatus(drop.id);

  return (
    <DropTeaser
      drop={drop}
      isSubscribed={isSubscribed}
      subscribeCTA={
        translations.overview.subscribe[isSubscribed ? 'confirmed' : 'cta']
      }
      disableSharing
    />
  );
};
